export default {
  BusinessLogisticsProductLang: {
    productCode: '产品编码',
    productName: '产品名称',
    scanNode: '获取流程单号节点',
    productType: '产品类型',
    orderType: '订单类型',
    status: '状态',
    departurePortCity: '出发口岸城市',
    specialGoodsType: '特殊物品类型',
    weightUnit: '重量单位',
    lengthUnit: '长度单位',
    sortNum: '排序',
    deliveryDays: '时效说明',
    waybillSource: '运单来源',
    sheetType: '面单类型',
    operation: '操作',
    addProduct: '新增产品',
    editProduct: '编辑产品',
    productEdit: '产品设置',
    supplier: '供应商',
    createdOn: '创建时间',
    basicInfo: '基础信息',
    goodsConfig: '物品配置',
    businessConfig: '业务配置',
    otherConfig: '其他配置',
    productCodePlaceholder: '若留空，系统会自动编码',
    productNamePlaceholder: '请输入产品名称',
    allowModifyOrder: '允许改订单',
    arrearsStopService: '欠款终止服务',
    generalGoods: '普货',
    innerBattery: '内电',
    pureBattery: '纯电',
    magnetic: '带磁',
    liquid: '液体',
    powder: '粉末',
    kilogram: '千克',
    centimeter: '厘米',
    arrivalScanNode: '到港时获取',
    inboundScanNode: '入仓后获取',
    scanNodeTips: '设置后不允许更改，请谨慎设置',
    orderTypeTips: '设置后不允许更改，请谨慎设置',
    smallPackage: '小包',
    express: '快递',
    fba: 'FBA',
    minDeliveryDays: '最短耗时（天）',
    maxDeliveryDays: '最长耗时（天）',
    minDeliveryDaysPlaceholder: '请输入最小天数',
    maxDeliveryDaysPlaceholder: '请输入最大天数',
    dayUnit: '天',
    businessChannel: '选择服务渠道',
    businessChannelPlaceholder: '请选择服务渠道',
    maxDeliveryDaysLessThanMin: '最长耗时不能小于最短耗时',
    productRules: '产品规则',
    labelRules: '面单规则',
    deliveryTrackingNumberSettings: '派送单号设置',
    zones: '分区',
    trackingDataFetchSettings: '轨迹抓取设置',
    serviceZone: '服务分区',
    remoteZone: '偏远分区',
  },
};
